<div class="getting-started">
  @if (showInfoCard()) {
    <div class="getting-started__info-card">
      <ocp-themed-icon
        name="early-access.svg"
        [width]="121"
        [height]="107"
        class="getting-started__illustration"
      />
      <div class="getting-started__info-body">
        <h2 class="getting-started__title">
          {{ 'getting-started.early-access-title' | translate }}
        </h2>
        <p class="getting-started__description">
          {{ 'getting-started.early-access-description' | translate }}
        </p>
        <a
          [href]="helpCenterUrl"
          target="_blank"
          rel="noopener noreferrer"
          class="getting-started__help-btn"
        >
          <ocp-themed-icon name="open-in-new.svg" [size]="18" />
          {{ 'getting-started.open-help-center' | translate }}
        </a>
      </div>
    </div>
  }

  @if (showSetupCard()) {
    <div class="getting-started__setup-card">
      <h2 class="getting-started__title">
        {{ 'getting-started.setup-workspace-title' | translate }}
      </h2>
      <ol class="getting-started__steps">
        <li>{{ 'getting-started.setup-step-1' | translate }}</li>
        <li>{{ 'getting-started.setup-step-2' | translate }}</li>
        <li>{{ 'getting-started.setup-step-3' | translate }}</li>
        <li>{{ 'getting-started.setup-step-4' | translate }}</li>
        <li>{{ 'getting-started.setup-step-5' | translate }}</li>
      </ol>
      <p class="getting-started__setup-help">
        {{ 'getting-started.need-help' | translate }}
        <a
          [href]="helpCenterUrl"
          target="_blank"
          rel="noopener noreferrer"
          class="getting-started__setup-help-link"
          >{{ 'getting-started.visit-help-guide' | translate }}</a
        >.
      </p>
    </div>
  }
</div>
